// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lx-printable[data-v-49e65457]{height:100%}.lx-print-only[data-v-49e65457]{display:none}@media print{.lx-printable[data-v-49e65457]{visibility:visible;position:absolute;left:0;top:0;height:0;overflow:visible}.lx-print-only[data-v-49e65457]{display:block}}.lx-notes[data-v-49e65457]{margin-top:4px;font-size:12px}", ""]);
// Exports
module.exports = exports;
